import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

import ThemesStore from "@/store/modules/ThemesStore";
import UserStore from "@/store/modules/UserStore";
import {Util} from "@/_global/utils";
import GenerationsStore from "@/store/modules/GenerationsStore";
import StoresStore from "@/store/modules/StoresStore";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import SelectionsStore from "@/_common/api/store/modules/SelectionsStore";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import globalFilters from "@/filters";
import {deliousApiClientToLocalMode} from "@/_global/api_clients/DeliousApiClient";
import {cmsApiClientToLocalMode} from "@/_global/api_clients/CmsApiClient";
import ImagesStore from '@/store/modules/ImagesStore'

locale.use(lang)
Vue.use(ElementUI)

Vue.config.productionTip = false;

(async function () {
    if (Util.getUrlParam("local")) {
        // ローカルデータで実行するモード
        cmsApiClientToLocalMode();
        deliousApiClientToLocalMode();
    }

    // ログインチェック
    await UserStore.update();
    if (!UserStore.isAuthenticated) {
        location.href = Util.deliouTopPageUrl();
    }

    // 世代と店舗情報を取得
    await Promise.all([
        GenerationsStore.init(),
        StoresStore.init()
    ]);

    if(GenerationsStore.all.length > 1)
        alert("商品マスターに複数の世代のデータが登録されています。\n世代番号：" + GenerationsStore.selected.period_no + " のデータを使ってメニューを作成します。");


    // マスター系データは最初に一括取得しておく
    const periodId: number = GenerationsStore.selected.period_no;
    const storeId: number = StoresStore.all[0].code; // todo メニュー作成時、代表店舗にせず共通マスタにしたい(共通マスタにオプション付けられるようになったら変更）
    await Promise.all([
        DeliousItemsStore.init({ storeId: storeId, periodId: periodId }),
        ThemesStore.init(),
        ItemsStore.init(),
        SelectionsStore.init(),
        CondimentGroupsStore.init(),
        ImagesStore.init(),
    ])

    // グローバルフィルタを登録
    globalFilters();

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');

})();
